export default "__VITE_ASSET__BtH1$RR4__"